import React from 'react';
import { Select, ISelectOption } from '@salecycle/ui-component-library';
import { IClients } from '../../../../../entities';
import { useTranslation } from 'react-i18next';
import { useNewUserDispatch, useNewUserState } from '../../../context/useNewUserContext';
import { getBrandOptions } from 'sections/user-management/utils/helpers';

export interface IProps {
  clients: IClients;
}

export const BrandAccessLevel: React.FC<IProps> = ({ clients }: IProps) => {
  const { t } = useTranslation();
  const { user } = useNewUserState();
  const dispatch = useNewUserDispatch();

  const brandOptions = getBrandOptions(clients);

  const handleBrandChange = (selectedOption: ISelectOption<string>) => {
    dispatch({
      type: 'SET_SELECTED_BRAND_VALUE',
      payload: { selectedBrand: selectedOption },
    });
  };

  return (
    <Select
      ariaLabel={t('newUser.levels.brand')}
      label={t('newUser.levels.brand')}
      inputId="BrandSelect"
      onChange={handleBrandChange}
      options={brandOptions}
      value={user.selectedBrand}
      clearable={true}
      minLength={3}
      minLengthPlaceholder={t('common.minLengthPlaceholder', {
        minLength: 3,
      })}
      noOptionsPlaceholder={t('common.noOptionsPlaceholder')}
    />
  );
};
